import React from 'react'

export const PreviewParagraphs = ({ text }: { text: string }) => (
  <>
    {text
      .split('\n')
      .filter(p => p.trim().length > 0)
      .map((p, i) => (
        <p key={i} style={{ textAlign: 'left', margin: 0, fontSize: '1.3rem' }}>
          <BoldWords text={p} />
        </p>
      ))}
  </>
)

// Matches "HORSE NAME (12)" or "HORSE NAME 12" — parens optional, 1-2 digit number, not followed by digits or decimals

const HORSE_PATTERN =
  /\b((?:[A-Z]{2,}(?:'[A-Z]+)?)(?:[ -](?:[A-Z]{2,}(?:'[A-Z]+)?)){0,8})(\s*\(\d{1,2}\))?/g

const BoldWords: React.FC<{ text: string }> = ({ text }) => {
  const segments: React.ReactNode[] = []
  let lastIndex = 0

  for (const match of text.matchAll(HORSE_PATTERN)) {
    if (match.index > lastIndex) segments.push(text.slice(lastIndex, match.index))
    segments.push(
      <strong key={match.index}>
        {match[1] ?? ''}
        {match[2] ?? ''}
      </strong>
    )
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < text.length) segments.push(text.slice(lastIndex))
  return <span>{segments}</span>
}
